<template>
  <div class="checkhandlemodule">
    <el-form :model="form" label-width="70px">
      <el-form-item label="审批结果：">
        <el-radio-group v-model="form.checkResult">
          <el-radio label="通过"></el-radio>
          <el-radio label="不通过"></el-radio>
        </el-radio-group>
      </el-form-item>
      <!--   坏账审批 ==> 唯一的特殊审批  start  -->
      <div v-if="baddebtcheck && form.checkResult === '通过'">
        <h6 style="margin:0px 10px 20px;font-size:16px;">结算方案</h6>
        <el-row>
          <el-col :lg="10" :md="12">
            <div class="pb20">
              <span style="width:80px;text-align: right;">提成扣除：</span>
              <el-input type="Number" v-model="baddebtCheckData.royalty" style="width:280px;"></el-input>
            </div>
          </el-col>
          <el-col :lg="10" :md="12">
            <div class="pb20">
              <span style="width:80px;text-align: right;">公司承担：</span>
              <el-input type="Number" v-model="baddebtCheckData.company" style="width:280px;"></el-input>
            </div>
          </el-col>
        </el-row>
      </div>
      <!--   end   -->
      <el-form-item label="备注：">
        <el-input
          maxlength="150"
          show-word-limit
          type="textarea"
          v-model="form.remark"
          placeholder="审核不通过时备注不可为空"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="openDialog">提交</el-button>
      </el-form-item>
    </el-form>
    <base-dialog :dialogVisible.sync="dialogVisible" :disableds="submitDisable"  @successEv="submitCheck">
      <div style="padding-left: 30px;padding-bottom: 38px;">{{dialogTxt}}</div>
    </base-dialog>
  </div>
</template>

<script>
import baseDialog from '@/components/module/baseDialog'
import { deepClone } from '@/util'

export default {
  name: 'checkHandleModule',
  components: {
    baseDialog
  },
  data () {
    return {
      dialogVisible: false,
      baddebtCheckData: {
        royalty: '',
        company: ''
      }
    }
  },
  computed: {
    dialogTxt () {
      const {
        passDialogTxt,
        nopassDialogTxt
      } = this
      return this.checkFromData.checkResult === '通过' ? passDialogTxt : nopassDialogTxt
    },
    form: {
      get () {
        return this.checkFromData
      },
      set (val) {
        return val
      }
    }
  },
  props: {
    checkFromData: {
      type: Object,
      default: () => {
        return {
          checkResult: '通过',
          remark: ''
        }
      }
    },
    checkData: {
      type: Object,
      default: () => { }
    },
    // dialog 通过时候的提示
    passDialogTxt: {
      type: String,
      default: '确认审批通过吗'
    },
    // dialog 不通过时候的提示
    nopassDialogTxt: {
      type: String,
      default: '审批不通过流程结束，申请人可再次发起申请'
    },
    // 需不需要dialog 默认需要
    notDialog: {
      type: Boolean,
      default: false
    },

    submitDisable: {
      type: Boolean,
      default: false
    },
    baddebtcheck: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openDialog () {
      const {
        remark,
        checkResult,
        notDialog
      } = this.form
      if (notDialog) {
        this.submitCheck()
        return
      }
      if (!remark && checkResult === '不通过') {
        this.$message({
          message: '请填写备注',
          type: 'error'
        })
        return
      }
      /** *******  坏账审批   ************/
      const {
        baddebtcheck,
        form
      } = this
      if (baddebtcheck && form.checkResult === '通过') {
        const { baddebtCheckData } = this
        const { financeBadDebtListVo } = this.checkData
        if (!baddebtCheckData.company && !baddebtCheckData.royalty) {
          this.$message.error('请制定结算方案！')
          return
        }
        const company = Number(baddebtCheckData.company)
        const royalty = Number(baddebtCheckData.royalty)
        const price = company + royalty
        if (financeBadDebtListVo && financeBadDebtListVo.badCount && price !== Number(financeBadDebtListVo.badCount)) {
          this.$message.error('结算方案与申请坏账金额不一致！')
          return
        }
        this.form = Object.assign(form, { commissionDeduction: royalty, companyCommitment: company, baddebtFlag: true })
      }
      /** *******  坏账审批   ************/
      this.dialogVisible = true
    },
    submitCheck () {
      const { form } = this
      this.$emit('submitCheck', deepClone(form))
    }
  }
}
</script>

<style scoped>
.el-form-item.el-form-item--mini:last-child {
  margin-bottom: 0 !important;
}
</style>
